
import { defineComponent, reactive, onMounted, computed, watch, ref } from "vue";
import { common } from "@/common/services/Common";



export default defineComponent({
  name: "ChannelChatMembers",
  props: {
    isShow: Boolean,
    imageUrl: String,
    members: Array,
    userRole: String
  },
  components: {
  },
  setup(props, { emit }) {
    const activeTooltipIndex = ref(null);
    const state = reactive({
      mobile: "",
      data: {
        currentChannel: '' as any,
      },
      ui: {
        successMessage: '',
        isActive: {
          upgradeSubscription: false,
        },
        modal: {
          showProjectAcknowledgementModal: false,
          showEditProjectAcknowledgementModal: false,
          selectedFromChannel: false,
        },
        isLoading: {
          projectDetailsAPICalled: false,
        },
        isPostLoading: {
          modifyHistoryDateForMember: false,
        },
        errors: {
          errorList: {
            modifyHistoryDateForMember: [] as any,
          },
          hasError: false,
        },
      },
    });

    const hideChannelMemberModal = () => {
      $("#chatChannelMemberModal").modal("hide");
      emit("closeChannelChatMembersModal");
    }
    function formatDate(date: any) {
      if (!date) return 'N/A';
      const dateTimeString = common.localDateAndTime(date);
      return dateTimeString.split(',')[0];
    }
    function calculateValidTill(completedDate: any, validityDays: any) {
      const date = new Date(completedDate);
      if (isNaN(date.getTime()) || !validityDays) return 'N/A';
      date.setDate(date.getDate() + Number(validityDays));
      const fullDateTime = common.localDateAndTime(date.toISOString());
      return fullDateTime.split(',')[0];
    }

    onMounted(() => {
      // getUserList();
      if (props.isShow) {
        $("#chatChannelMemberModal").modal("show");
      }
    });
    return {
      state,
      hideChannelMemberModal,
      activeTooltipIndex,
      formatDate,
      calculateValidTill
    };
  },
});
